import { ProtocolQuery } from '../../../service-model/protocol-query.interface';
import { SHELL_PROTOCOL_OPERATIONS_NS } from '../shell-protocol-namespace.const';

export interface TelegramConnectionReply { status: string; email?: string; requestId?: string; linkUrl?: string; expiresUtc?: string; telegramUserId?: number; telegramName?: string; }
export class TelegramConnections implements ProtocolQuery {
  constructor(public readonly action: 'List' | 'CreateQr' | 'QrStatus' | 'CancelQr' | 'Revoke', public readonly requestId?: string) {}
  getOperationName(): string { return `${SHELL_PROTOCOL_OPERATIONS_NS}.TelegramConnections`; }
}
